// extracted by mini-css-extract-plugin
module.exports = {"form":"TAHManagement_form__1ORVx","content":"TAHManagement_content__3Kevx","contentMain":"TAHManagement_contentMain__3gjaY","select":"TAHManagement_select__2nD2J"};